/* eslint-disable */
let reduxStore = null;
// this is store provider, it removes circular dependncy from usage places
/*
initializes store
 */
export const initStore = function (initialStore) {
  reduxStore = initialStore;
};

export const getStore = function () {
  if (!reduxStore) {
    console.error(
      'store has not been initialized, you probably doing something wrong, init store first',
    );
  }
  return reduxStore;
};
